import React from 'react';
import { useParams } from 'react-router-dom';
import { capitalize } from './routeUtils';

// se hacen estos imports manuales HORRIBLES porque react lazy no soporta imports dinámicos de archivos locales
// si se te ocurre una mejor forma de hacerlo, bienvenido seas
// JEJE SALU2

import LatamEs from '../pages/Es/Mercados/Latam.js';
import AfricaEs from '../pages/Es/Mercados/Africa.js';
import LatamEn from '../pages/En/Markets/Latam.js';
import AfricaEn from '../pages/En/Markets/Africa.js';
import LatamPt from '../pages/Pt/Mercados/Latam.js';
import AfricaPt from '../pages/Pt/Mercados/Africa.js';
import PaymentDetailEs from '../pages/Es/Mercados/PaymentMethodDetails.js';
import PaymentDetailEn from '../pages/En/Markets/PaymentMethodDetails.js';
import PaymentDetailPt from '../pages/Pt/Mercados/PaymentMethodDetails.js';

const regionComponents = {
  es: { Latam: LatamEs, Africa: AfricaEs },
  en: { Latam: LatamEn, Africa: AfricaEn },
  pt: { Latam: LatamPt, Africa: AfricaPt }
};

const paymentMethodDetailsComponents = {
  es: PaymentDetailEs,
  en: PaymentDetailEn,
  pt: PaymentDetailPt
};

const regionFiles = {
  en: ['Latam', 'Africa'],
  es: ['Latam', 'Africa'],
  pt: ['Latam', 'Africa']
};

const MarketRouteHandler = ({ lang }) => {
  const { param } = useParams();
  const regions = regionFiles[lang] || [];
  const regionName = capitalize(param);
  const isRegion = regions.includes(regionName);

  const ComponentToRender = isRegion
    ? regionComponents[lang]?.[regionName]
    : paymentMethodDetailsComponents[lang];

  if (!ComponentToRender) {
    return (
      <div>
        No se encontró el componente para <strong>{lang}</strong> / <strong>{regionName}</strong>
      </div>
    );
  }

  return <ComponentToRender />;
};

export default MarketRouteHandler;
